//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DisableSubmissionRepopulation: FeatureFlag = {"Id":"DisableSubmissionRepopulation","Label":"(Performance) Disable repopulating submissions ","Impact":"Normally, on starting a new submission, the system attempts to copy field data configured to be repopulating from the last submission into the new submission. When this is enabled, the new submission is always created blank.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
